var signInButton;
var signUpButton;
var signInSection;
var signUpSection;

var accountMenu;

function initialiseMobileMenu() {
  var openButton = $('#mobile-menu-open-button');
  var closeButton = $('#mobile-menu-close-button');
  var menu = $('.drawer-menu');

  openButton.on('click', function handleOpenMenu() {
    menu.addClass('open');
    openButton.hide();
    closeButton.show();
  });

  closeButton.on('click', function handleCloseMenu() {
    menu.removeClass('open');
    accountMenu.removeClass('open');
    openButton.show();
    closeButton.hide();
  });
}

function showSignUpSection() {
  signUpButton.addClass('active');
  signInButton.removeClass('active');
  signInSection.hide();
  signUpSection.show();
}

function showSignInSection() {
  signUpButton.removeClass('active');
  signInButton.addClass('active');
  signInSection.show();
  signUpSection.hide();
}

function initialiseAccountDrawer() {
  signInButton = $('.sign-in-button');
  signUpButton = $('.sign-up-button');
  signInSection = $('#customer_login');
  signUpSection = $('#create_customer');

  signUpSection.hide();

  signInButton.on('click', showSignInSection);
  signUpButton.on('click', showSignUpSection);

  var openButton = $('.account-menu-open-button');
  var closeButton = $('#account-menu-close-button');
  accountMenu = $('.customer-drawer-menu');

  openButton.on('click', function handleOpenMenu() {
    accountMenu.addClass('open');
  });

  closeButton.on('click', function handleCloseMenu() {
    accountMenu.removeClass('open');
  });
}

function toggleLevel2() {
  $('.drawer-menu__dropdown').click(function () {
    $(this).nextAll('.drawer-menu__level-2-menu').first().slideToggle(150).toggleClass('active');
    $(this).toggleClass('active');
  });
}

function showSearchBar() {
  $('.search-button').click(function(event) {
    event.stopPropagation();
    var form = $('.search-bar');
    var innerInput = $('.search-bar' + ' input');

    form.addClass("fade-in show");

    if (innerInput.length > 0) {
      innerInput[0].focus();
    }

    $(innerInput).focusout(function () {
        setTimeout(function() {form.removeClass("fade-in show");
      }, 100)});
  });
}

function initialiseNestedImagesControls() {
  const links = $('.mega-menu__level-2-item');

  links.hover(function () {
    const data = $(this).data();

    $('.child-image-' + data.levelOneIndex).hide();
    $('.child-image-' + data.levelOneIndex + '-' + data.levelTwoIndex).show();
  });
}

function itemAddedCallback() {
  window.location.reload();
}

function updateCart(cart) {
  $('.cart-count').text(cart.item_count);

  cart.items.forEach(function (item, index) {
    var itemPrice = theme.Currency.formatMoney(item.line_price,'{{amount_no_decimals}}€');
    $('#mini-basket-price-' + index).text(itemPrice);
    $('#cart-' + index).text(itemPrice);
  });

  var totalPrice = theme.Currency.formatMoney(cart.total_price,'{{amount_no_decimals}}€');
  $('.cart-template__total-price').text(totalPrice);
}

// SON — Handlers quantite en DELEGATION d'evenements.
// Avant : $('.qty-minus-button').on('click', ...) liait directement les boutons
// presents au chargement. Le mini-panier (.cart-popup) est desormais remplace
// dans le DOM apres un ajout au panier (product-page.js) ; une liaison directe
// serait perdue au swap. La delegation sur document survit au remplacement.
function initialiseCartActions() {
  $(document).on('click', '.qty-minus-button', function () {
    var target = $(this).data('target');
    var input = $('.' + target);
    var inputLabel = $('.label_' + target);

    var currentQty = parseInt(input.val(), 10);

    if (currentQty > 0) {
      var newQty = currentQty - 1;
      var line = target.replace('updates_', '');
      input.val(newQty);
      inputLabel.text(newQty);
      $('.qty-plus-button[data-target="'+target+'"]').removeClass('disabled-qty');
      if(newQty == 0) {
        ShopifyAPI.changeItem(line, newQty, itemAddedCallback);
      } else {
        ShopifyAPI.changeItem(line, newQty, updateCart);
      }
    }
  });

  $(document).on('click', '.qty-plus-button', function () {
    var target = $(this).data('target');
    var input = $('.' + target);
    var inputLabel = $('.label_' + target);

    var currentQty = parseInt(input.val(), 10);

    if (currentQty < parseInt(input.attr('max'))) {
      var newQty = currentQty + 1;
      var line = target.replace('updates_', '');
      input.val(newQty);
      inputLabel.text(newQty);

      if(newQty == parseInt(input.attr('max'))) {
        $(this).addClass('disabled-qty');
      }

      ShopifyAPI.changeItem(line, newQty, updateCart);
    }
  });
}

function main() {
  document.documentElement.style.setProperty('--vh', `${window.innerHeight/100}px`);

  initialiseMobileMenu();
  initialiseAccountDrawer();
  toggleLevel2();
  showSearchBar();
  initialiseNestedImagesControls();
  initialiseCartActions();
}

$('document').ready(main);
